import React from "react";
import classes from "./ContentViewer.module.css";
import TinyMCEViewer from "./TinyMCEViewer";

const ContentViewer = ({ data, contentDirPath = '' }) => {
    return <div className={classes.ContentViewer} style={data && data.bgImage ? { backgroundImage: `url(${contentDirPath}${data.bgImage.url})`, ...data.bgImage } : {}}>
        {data.video &&
            (data.video.isFile ?
                <video
                    className={classes.Video}
                    src={`${contentDirPath}${data.video.url}`}
                    style={{ ...data.video, position: 'absolute' }}
                    controls /> :
                <iframe
                    className={classes.Video}
                    src={data.video.url}
                    style={{ ...data.video, position: 'absolute' }}
                    frameBorder="0"
                    allowFullScreen></iframe>)
        }
        <div className={classes.BGImage}></div>
        <TinyMCEViewer contentDirPath={contentDirPath} data={data.html}></TinyMCEViewer>
    </div>
}

export default ContentViewer;